import { IModifyTicketSupportPayload } from "pages/request-support/interfaces/apis";
import { api } from "../helpers/api";

const filterRequestSupport = async (
  shopId: string | null,
  status: string | null,
  page: number,
  size: number) => {
  const params = { shopId, status, size, page };
  return await api.get('/api/v1/admin/request-support/all', { params }).then((response: any) => {
    return response;
  });
};

const updateStatus = async (
  supportIds: string[],
  status: string,
  shopId: string | null) => {
  const payload = { supportIds, status, shopId };
  return await api.post('/api/v1/admin/request-support/update-status', payload).then((response: any) => {
    return response;
  });
};

const updateNote = async (
  supportId: string,
  note: string) => {
  const payload = { supportId, note };
  return await api.post('/api/v1/admin/request-support/update-note-reply', payload).then((response: any) => {
    return response;
  });
};

const getListRequestSupport = async (shopId: string | null) => {
  const params = { shopId };
  return await api.get('/api/v1/admin/request-support/list', { params }).then((response: any) => {
    return response;
  });
};

const updateStatusRequestSupport = async (
  status: string,
  id: string) => {
  const payload = { id, status };
  return await api.post('/api/v1/admin/request-support/update-status', payload).then((response: any) => {
    return response;
  });
};

const updateAssignEmployee = async (
  id: string,
  assignId: string) => {
  const payload = { id, assignId };
  return await api.post('/api/v1/admin/request-support/update-assign-employee', payload).then((response: any) => {
    return response;
  });
};

const addComment = async (
  id: string,
  note: string) => {
  const payload = { id, note };
  return await api.post('/api/v1/admin/request-support/comment', payload).then((response: any) => {
    return response;
  });
};

const modifyRequestSupport = async ( body: IModifyTicketSupportPayload) => {
  return await api.post('/api/v1/admin/request-support/modify-ticket', body).then((response: any) => {
    return response;
  }
  );
};

const getDetailRequestSupport = async (ticketId: string) => {
  return await api.get(`/api/v1/admin/request-support/detail/${ticketId}`).then((response: any) => {
    return response;
  }
  );
};

const deleteRequestSupport = async (ticketId: string) => {
  return await api.delete(`/api/v1/admin/request-support/delete/${ticketId}`).then((response: any) => {
    return response;
  }
  );
};

const requestSupportApis = {
  filterRequestSupport,
  updateStatus,
  updateNote,
  getListRequestSupport,
  updateStatusRequestSupport,
  updateAssignEmployee,
  addComment,
  modifyRequestSupport,
  getDetailRequestSupport,
  deleteRequestSupport,
};

export default requestSupportApis;
